"use client";

import { Button } from "@/components/ui/button";

import { AdSenseResponsive } from "./adsense-responsive";
import { RequiredBuyPremiumButton } from "./required/buy-premium-button";
import { phoneSupport } from "@/constants";

interface AdProps {
  adType: "google" | "contact" | "paywall";
}

export const AdTypes = ({ adType }: AdProps) => {
  // Contact Ad - for advertisers
  if (adType === "contact") {
    return (
      <div className="w-full h-full flex flex-col gap-2 items-center justify-center p-8 text-center bg-gradient-to-r from-blue-50 to-indigo-50">
        <h3 className="text-lg font-semibold">Anuncie aqui</h3>
        <p className="text-sm text-muted-foreground">
          Quer anunciar seu negócio para investidores imobiliários?
        </p>
        <div className="w-full mt-4">
          <Button asChild variant="outline">
            <a
              href={`https://wa.me/${phoneSupport}?text=Olá,%20quero%20anunciar%20no%20Pro%20Leilão...`}
              target="_blank"
              rel="nofollow"
              className="w-full"
            >
              Entre em contato
            </a>
          </Button>
        </div>
      </div>
    );
  }

  // Paywall Ad - encourages users to upgrade
  if (adType === "paywall") {
    return (
      <div className="w-full h-full flex flex-col gap-2 items-center justify-center p-8 text-center bg-gradient-to-r from-blue-50 to-indigo-50">
        <h3 className="text-lg font-semibold">Remova os anúncios</h3>
        <p className="text-sm text-muted-foreground">
          Assine o plano para uma experiência sem anúncios e acesso a recursos
          exclusivos.
        </p>
        <div className="w-full mt-4">
          <RequiredBuyPremiumButton label="Assinar agora" />
        </div>
      </div>
    );
  }

  // Fallback to Google Ad if type is not recognized
  return (
    <div className="w-full min-w-32 min-h-32">
      <div className="absolute z-[1] left-0 top-0 bg-slate-100 px-2 py-0.5 rounded-br-lg">
        <span className="flex items-center justify-center text-muted-foreground text-xs">
          Propaganda
        </span>
      </div>
      <AdSenseResponsive.CheckPlan
        orientation="card"
        variant="propertiesList"
      />
    </div>
  );
};
